module.exports = __webpack_public_path__ + "static/media/crosshairs.66f3174b.svg";